import { useReducer } from 'react'

import { Box, Title } from '@factorialco/deprecated-design-system'
import { BenefitsHomePageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { BenefitModalContext } from 'modules/benefits/components/benefitModals/BenefitModalContext'
import BenefitModals from 'modules/benefits/components/benefitModals/BenefitModals'
import { benefitModalReducer } from 'modules/benefits/components/benefitModals/reducer'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { BenefitsCardBenefitList } from './BenefitsCardBenefitList'

const BenefitsHomePage = () => {
  const {
    company: { id: companyId },
  } = useCurrentSession()

  const { data } = useQuery(BenefitsHomePageDocument, {
    variables: {
      companyId: companyId,
    },
  })
  const featureAvailabilities = data?.companies?.featureAvailabilitiesConnection?.nodes

  useEffect(() => {
    track(trackingEvents.benefits.openBenefitsHomePage)
  }, [])

  const [modalState, modalDispatch] = useReducer(benefitModalReducer, {
    openModal: null,
  })

  const healthcarePlans = data?.benefits?.healthcarePlansConnection?.nodes

  return (
    <ResponsivePage.Body variant="full">
      <Box gap="s32">
        <Title
          variant="400"
          title={i18n.t('benefits.tabs.overview.page.title')}
          description={i18n.t('benefits.tabs.overview.page.description')}
        />

        <BenefitModalContext.Provider value={{ state: modalState, dispatch: modalDispatch }}>
          <BenefitsCardBenefitList
            showStatus
            {...{
              featureAvailabilities,
              healthcarePlans,
            }}
          />

          <BenefitModals />
        </BenefitModalContext.Provider>
      </Box>
    </ResponsivePage.Body>
  )
}

export default BenefitsHomePage
